module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogined) ? _c('div', {
    staticClass: "updatePasswordContent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('div', {
    staticClass: "oldPassword"
  }, [_c('div', [_vm._v("原密码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.currentPassword),
      expression: "form.currentPassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入原密码"
    },
    domProps: {
      "value": (_vm.form.currentPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "currentPassword", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "newPassword"
  }, [_c('div', [_vm._v("新密码：")]), _vm._v(" "), ((_vm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.newPassword),
      expression: "form.newPassword"
    }],
    attrs: {
      "placeholder": "请输入新密码",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.newPassword) ? _vm._i(_vm.form.newPassword, null) > -1 : (_vm.form.newPassword)
    },
    on: {
      "keyup": _vm.toCheckPassword,
      "change": function($event) {
        var $$a = _vm.form.newPassword,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "newPassword", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "newPassword", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "newPassword", $$c)
        }
      }
    }
  }) : ((_vm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.newPassword),
      expression: "form.newPassword"
    }],
    attrs: {
      "placeholder": "请输入新密码",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.form.newPassword, null)
    },
    on: {
      "keyup": _vm.toCheckPassword,
      "change": function($event) {
        return _vm.$set(_vm.form, "newPassword", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.newPassword),
      expression: "form.newPassword"
    }],
    attrs: {
      "placeholder": "请输入新密码",
      "type": _vm.passwordType
    },
    domProps: {
      "value": (_vm.form.newPassword)
    },
    on: {
      "keyup": _vm.toCheckPassword,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "newPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.passwordType === 'password') ? _c('img', {
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/se21a0a57445b47f30e25aa15ddae8d94.png"
    },
    on: {
      "click": _vm.handlePassword
    }
  }) : _c('img', {
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/s863608c680ccd0900caff867a42cf508.png"
    },
    on: {
      "click": _vm.handlePassword
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "passwordStrength"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("强度：")]), _vm._v(" "), _c('div', {
    staticClass: "pw-strength"
  }, [_c('div', {
    class: (_vm.passwordLen < 6 ? ' pw-defule' : (_vm.passwordVal == 1 ? ' pw-weak' : (_vm.passwordVal == 2 ? ' pw-medium' : ' pw-strong')))
  }, [_c('div', {
    staticClass: "pw-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "pw-bar-on"
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "confirmPassword"
  }, [_c('div', [_vm._v("确认密码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password_confirmation),
      expression: "form.password_confirmation"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入确认密码"
    },
    domProps: {
      "value": (_vm.form.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password_confirmation", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "savePassword"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "保存密码",
      "loading": _vm.isLoading,
      "disabled": _vm.isReset
    },
    on: {
      "click": _vm.submitForm
    }
  })])]) : _c('div', {
    staticClass: "updatePasswordContent1"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.toLogin()
      }
    }
  }, [_vm._v("亲,请先登陆")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pw-txt"
  }, [_c('span', [_vm._v("弱")]), _vm._v(" "), _c('span', [_vm._v("中")]), _vm._v(" "), _c('span', [_vm._v("强")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c69ed9f6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/password/Reset.vue
// module id = 781
// module chunks = 2